import type { ReactNode } from 'react';
import { Spinner } from './Spinner';

/**
 * 목록 위 도구 줄 안의 드롭다운 폭 — 데스크탑(sm 이상)은 Figma 200px,
 * 모바일은 한 줄에 나란히 들어가도록 남는 폭을 나눠 쓴다.
 */
export const TOOLBAR_SELECT_CLASS = 'min-w-0 flex-1 sm:w-[200px] sm:flex-none';

interface ListToolbarProps {
  /** '총 12개 업체' · '등록률 75% (36 / 48)' 같은 요약 문구 */
  summary: ReactNode;
  /** 정렬 · 보기 · 필터 */
  controls: ReactNode;
  /** 오른쪽 검색창 */
  search: ReactNode;
  /** 이전 결과를 보여 주며 새 조건으로 다시 불러오는 중 — 요약 옆에 작은 스피너 */
  isRefreshing?: boolean;
}

/**
 * Figma 목록 상단 도구 줄 — [요약 · 정렬 · 보기 · 필터] ··· [검색].
 * 데스크탑은 한 줄(Figma 그대로), 폭이 모자라면 검색창이 다음 줄로 내려가고,
 * 모바일은 요약 / 드롭다운 / 검색을 각각 한 줄씩 쌓는다.
 */
export function ListToolbar({
  summary,
  controls,
  search,
  isRefreshing = false,
}: ListToolbarProps) {
  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-3">
      <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
        <div className="flex w-full items-center gap-2 sm:w-auto">
          {summary}
          {isRefreshing && (
            <Spinner size="sm" label="목록을 새로 불러오는 중" />
          )}
        </div>
        <div className="flex w-full items-center gap-2 sm:w-auto">
          {controls}
        </div>
      </div>
      {search}
    </div>
  );
}
